import {
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  Avatar,
  ListItemText,
  Box,
} from "@mui/material";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import getConnectionIcon from "@arelia-utils/helpers/getConnectionIcon";
import { ConnectionName } from "@arelia-types/connection";

type Props = {
  networks: {
    name: ConnectionName;
    total: number;
  }[];
  loading: boolean;
  error: boolean;
  unconnected: boolean;
};

const mapConnectionLabels: { [key: string]: any } = {
  [ConnectionName.youtube]: "subscribers",
  [ConnectionName.facebook]: "fans/likes"
};

export default function NetworksPresenter({ networks, loading, error, unconnected }: Props) {

  return (
    <WidgetCard
      widgetId="NETWORKS"
      title="Top Social Networks"
      loading={loading}
      error={error}
      unconnected={unconnected}
    >
      <Box width={1}>
        <List>
          {networks.map(({ name, total }, index) => (
            <ListItem key={name} sx={{ px: 0, py: 1 }}>
              <ListItemAvatar sx={{ minWidth: 47 }}>
                <Avatar sx={{ borderRadius: "initial", width: 32, height: 32 }} src={getConnectionIcon(name)} />
              </ListItemAvatar>
              <ListItemText
                primary={name}
                primaryTypographyProps={{ variant: "subtitle2", style: { fontSize: 14 } }}
              />
              <ListItemSecondaryAction>
                <Typography
                  variant="subtitle2"
                  color="secondary"
                  sx={{ letterSpacing: "0.1em", fontWeight: 600, fontSize: 12, textTransform: "uppercase" }}
                >
                  {total} {mapConnectionLabels[name] ?? "followers"}
                </Typography>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Box>
    </WidgetCard>
  );
}
